'use client';

import React from 'react';
import { AnimatePresence } from 'framer-motion';

import { Box, BoxProps } from '../box';

export interface CollapseProps
  extends Omit<BoxProps, 'animationDuration' | 'animationTimingFunction'> {
  /** Whether the content is visible */
  isOpen: boolean;
  /** Animation duration as a string (e.g., '0.2s', '200ms') */
  animationDuration?: string;
  /** Animation timing function */
  animationTimingFunction?: string;
  /** Start height when collapsed */
  startingHeight?: number | string;
  /** End height when expanded */
  endingHeight?: number | string;
}

/**
 * Collapse component for showing/hiding content with animation
 */
export const Collapse: React.FC<CollapseProps> = ({
  isOpen,
  // animationDuration = 0.2,
  // animationTimingFunction = 'ease-in-out',
  // startingHeight = 0,
  // endingHeight = 'auto',
  children,
  ...boxProps
}) => {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <Box overflow="hidden" {...boxProps}>
          {children}
        </Box>
      )}
    </AnimatePresence>
  );
};

export default Collapse;
